import { Link } from "react-router-dom";
import { SearchX, PauseCircle, Ban, AlertTriangle } from "lucide-react";

const COPY = {
  unknown: { icon: SearchX, title: "School not found", text: "We couldn't find a preschool at this address. Please check the link." },
  inactive: { icon: PauseCircle, title: "Website temporarily unavailable", text: "This preschool's website is currently paused. Please contact the school directly." },
  reserved: { icon: Ban, title: "This address is reserved", text: "This subdomain is used by the platform and can't host a school website." },
  invalid: { icon: Ban, title: "Invalid address", text: "This web address isn't a valid school website." },
  error: { icon: AlertTriangle, title: "Something went wrong", text: "Please refresh the page in a moment." },
};

export default function SiteStatus({ kind, slug }) {
  const c = COPY[kind] || COPY.error;
  const Icon = c.icon;
  return (
    <div className="min-h-screen bg-brand-soft dots-bg flex items-center justify-center px-6" data-testid={`site-status-${kind}`}>
      <div className="bg-white rounded-3xl border p-8 sm:p-10 max-w-md text-center rise">
        <Icon className="w-12 h-12 mx-auto text-brand mb-4" />
        <h1 className="text-2xl sm:text-3xl font-semibold mb-2" data-testid="site-status-title">{c.title}</h1>
        <p className="text-sm text-stone-500">{c.text}</p>
        {slug && <p className="mt-3 text-xs font-mono text-stone-400">{slug}</p>}
        <Link to="/" className="inline-block mt-6 px-5 py-2.5 rounded-full btn-brand text-sm font-semibold" data-testid="site-status-home-link">Go to homepage</Link>
      </div>
    </div>
  );
}
